import { ACCOUNT_API_PROFILE, } from './../../shared/constants/api-endpoint';
import { apiClient } from "shared/plugins/http-service";
import { ICurrentUserModel} from "./account.models";


export const getProfileAPI = async () => {
  return await apiClient.getHttp<ICurrentUserModel>(
    `${ACCOUNT_API_PROFILE}`,
  );
};